import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSplitValues = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "meal_plan",
	"data-name": "meal plan",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "9 6 5 2 1 6"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "23 6 19 2 15 6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M12,24V18.64A4.83,4.83,0,0,0,8.5,14h0A4.83,4.83,0,0,1,5,9.36V2"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M12,24V18.64A4.83,4.83,0,0,1,15.5,14h0A4.83,4.83,0,0,0,19,9.36V2"
		})
	]
});
const ForwardRef = forwardRef(SvgSplitValues);
export default ForwardRef;
